var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card-wrapper',{attrs:{"title":_vm.$t('honda.registration.list.title'),"id":"registrations-list"}},[_c('registrations-table',{attrs:{"filter-list":_vm.filters,"default-filters":_vm.defaultFilters}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }